export default __webpack_public_path__ + "static/media/Sim-card_24.1a277ff9.svg";